module.exports = __webpack_public_path__ + "static/media/main.bf2b7bb4.png";